import React from 'react';
import { ShowIf } from '../../../../components/ShowIf';
import { useBorrowerPmcHandleMode } from '../../../../../queries/BorrowerFields/PmcFields';

export type ManagementAgreementProvideLaterAdvisoryProps = {
    isReview: boolean;
};

export const ManagementAgreementProvideLaterAdvisory: React.FC<ManagementAgreementProvideLaterAdvisoryProps> = ({
    isReview = false,
}) => {
    const [managementAgreementHandle] = useBorrowerPmcHandleMode();

    return (
        <ShowIf showIf={isReview && managementAgreementHandle === 'providelater'}>
            <div
                style={{
                    padding: '15px 50px 15px 50px',
                }}
            >
                <strong>
                    <em>NOTE:</em>
                </strong>
                &nbsp; Management Agreement is needed to process your application and order a valuation. Please submit ASAP
                via&nbsp;
                <a href='mailto:team@builderfinance.com'>team@builderfinance.com</a>
                &nbsp; or&nbsp;
                <a
                    href='https://fileshare.bfiweb.com'
                    target='_blank'
                >
                    https://fileshare.bfiweb.com
                </a>
            </div>
        </ShowIf>
    );
};
